import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  Button,
  Box,
} from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';


export default function UploadResultDialog({
  open,
  onClose,
  header,
  results,
  onViewFile,
}) {

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>ผลการอัปโหลดไฟล์เข้า PW</DialogTitle>
      <DialogContent>
        <Typography
          style={{
            fontFamily: 'monospace',
            whiteSpace: 'pre-wrap',
            marginBottom: '16px',
          }}
        >
          {header}
        </Typography>

        {results?.map((r, index) => {
          const isSuccess = r.pwData.status === 'success';
          const filename = r.filename;
          const docTypeName = r.docTypeName;
          const info = isSuccess
            ? r.pwData.data.docID
            : r.pwData.message || 'ไม่มีไฟล์ประเภทนี้ใน PW';
          const docID = r?.docID;

          return (
            <Box
              key={index}
              sx={{
                mb: 1,
                fontFamily: 'monospace',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
              }}
            >
              {isSuccess ? (
                <CheckCircleIcon fontSize="small" color="success" />
              ) : (
                <ErrorIcon fontSize="small" color="error" />
              )}
              <Typography
                variant="body2"
                component="span"
                sx={{ fontFamily: 'monospace' }}  
              >
                {docTypeName} :: {info}
              </Typography>
              {docID && (
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  startIcon={<DescriptionIcon />}
                  onClick={() => onViewFile(docID)}
                >
                  {filename}
                </Button>
                //         <IconButton
                //           size="small"
                //           color="primary"
                //           onClick={() => onViewFile(docID)}
                //         >
                //           <DescriptionIcon fontSize="small" />
                //         </IconButton>
              )}
            </Box>
          );
        })}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          ปิด
        </Button>
      </DialogActions>
    </Dialog>
  );
}
